import { render, staticRenderFns } from "./customMenuBar.vue?vue&type=template&id=58be46c0&scoped=true&"
import script from "./customMenuBar.vue?vue&type=script&lang=js&"
export * from "./customMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./customMenuBar.vue?vue&type=style&index=0&id=58be46c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58be46c0",
  null
  
)

export default component.exports